import { formatUnits } from 'utils/units';
import React from 'react';
import { StakingPool, UserPoolInfo } from 'api/StakingAPI';
import { useTranslation } from 'react-i18next';
import { Typography } from '@dapp/multi-lib/sdaoui/Typography';
import { twMerge } from 'tailwind-merge';
import { shouldHighlightTokenAmount } from 'structure/staking/utils/stakingValueHighlight';

type UserClaimableProps = {
  pool: StakingPool;
  userPoolInfo: UserPoolInfo;
};

export function UserClaimable({ pool, userPoolInfo }: UserClaimableProps) {
  const { t } = useTranslation('common');
  const claimable = formatUnits(
    userPoolInfo?.claimable || '0',
    pool?.rewardsTokenDecimals
  );

  const maximumFractionDigits = Number(claimable) > 1000 ? 0 : 2;

  return (
    <Typography
      className={twMerge(
        'text-xs',
        shouldHighlightTokenAmount(userPoolInfo?.claimable)
          ? 'text-green'
          : 'text-[#B4BCD0]'
      )}
    >
      {t('tokenAmount', { value: claimable, maximumFractionDigits })}
    </Typography>
  );
}
